import { EnvironmentInjector, inject } from '@angular/core';

import { LazyComponentDetails } from '@core/shared/util';
import { LoginContextService } from '@mpk/shared/data-access';
import { SettingsFormPlugin, SettingsFormPluginComponent } from '@mpk/shared/util';

import { TransactionManagementOrganizationSettingsPermissions } from '../permissions';

/**
 * Factory to create the Transaction Management organization settings plugin.
 */
export function createTransactionManagementOrganizationSettingsPlugin(): SettingsFormPlugin {
  const loginContextService = inject(LoginContextService);

  return {
    settingsId: 'TransactionManagementOrganizationSettings',
    displayName: 'Belegsteuerung',
    description: 'Hier werden alle Belegsteuerungseinstellungen vorgenommen.',
    isEnabled: loginContextService.permission(TransactionManagementOrganizationSettingsPermissions.ManageSettings),
    async getComponentDetails(
      parentInjector: EnvironmentInjector,
    ): Promise<LazyComponentDetails<SettingsFormPluginComponent>> {
      const { TransactionManagementOrganizationSettingsEditComponent } = await import('../components');

      return {
        component: TransactionManagementOrganizationSettingsEditComponent,
        environmentInjector: parentInjector,
      };
    },
  };
}
